/**
 * Uma regra só pra voltar — e por que ela precisa existir.
 *
 * "Voltar" tem duas implementações possíveis e as duas estão erradas
 * sozinhas:
 *
 *  • `navigate(-1)` acerta quando a pessoa navegou até aqui, e falha quando
 *    a aba COMEÇOU aqui — link colado, favorito, recarregamento, ou uma aba
 *    aberta por nós com `target="_blank"`. Nesse caso não há pra onde
 *    voltar, e o botão ou não faz nada ou joga a pessoa pra fora do app.
 *
 *  • Um destino fixo (`to="/equipments"`) sempre funciona e quase sempre
 *    mente. Quem chegou ao ativo clicando num marcador da planta não veio
 *    da lista de ativos, e mandá-lo pra lá é desfazer o caminho dele.
 *
 * A regra é: volte de verdade quando houver de onde, e só então use o pai
 * declarado. O React Router marca a primeira entrada do histórico com
 * `location.key === "default"`, e é assim que dá pra distinguir os dois.
 */

import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export function useVoltar(paraSeSemHistorico = "/") {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(() => {
    if (location.key !== "default") navigate(-1);
    else navigate(paraSeSemHistorico);
  }, [navigate, location.key, paraSeSemHistorico]);
}
